import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { createVerificationMutation, createCommentMutation } from './api';
import DepartmentDropdown from './DepartmentDropdown';
import StatusDropdown from './StatusDropdown';
import { CommentsTimeline } from './CommentsTimeline';

interface Props {
  data: any;
}

const CreateVerificationForm = (props: Props) => {
  //TODO Get InventoryYear from settings
  const [comment, setComment] = useState('');
  const [createVerification] = useMutation(createVerificationMutation);
  const [createComment] = useMutation(createCommentMutation);
  const { user } = useSelector((state: any) => ({ user: state.user }));
  const [updateDisabled, setUpdateDisabled] = useState(false);
  let queryByAssetNumber = props.data.assetsViewByBarcode === undefined;

  const initialFormikValues = {
    id: null,
    status: 'Verified',
    barCode: queryByAssetNumber ? props.data.assetsViewByAssetNumber.BarCode : props.data.assetsViewByBarcode.BarCode,
    verifyDate: new Date(),
    userId: String(user.id),
    userDepartment: user.currentRole.department.Name,
    itemDepartment: user.currentRole.department.Name,
    InventoryYear: 2022,
    assetNumber: queryByAssetNumber ? String(props.data.assetsViewByAssetNumber.AssetNumber) : String(props.data.assetsViewByBarcode.AssetNumber),
    type: 'V',
    serialNumber: queryByAssetNumber ? props.data.assetsViewByAssetNumber.SerialNumber : props.data.assetsViewByBarcode.SerialNumber,
  };

  const createCommentForVerification = (verifyId: number) => {
    const commentObject: any = {
      verifyId: verifyId,
      barcode: queryByAssetNumber ? props.data.assetsViewByAssetNumber.BarCode : props.data.assetsViewByBarcode.BarCode,
      createdBy: user.adId,
      lastUpdatedBy: user.adId,
      comment: comment,
      updatedOn: new Date(),
      entryType: 'inventorycomment',
      requestId: null,
    };

    createComment({ variables: commentObject }).catch((err) =>
      console.log('Error: /frontend/src/components/VerificationForms/CreateVerificationForm//createCommentForVerification', err)
    );
  };

  const formik = useFormik({
    initialValues: initialFormikValues,
    onSubmit: async (values: any, e: any) => {
      setUpdateDisabled(true);
      createVerification({ variables: values })
        .then((res) => {
          if (comment !== '') {
            createCommentForVerification(res.data.createVerification.VerifyId);
          }
          window.location.href = `/inventory/editVerification/verifyId=${res.data.createVerification.VerifyId}/${false}/${true}`;
        })
        .catch((err) => {
          alert('Issue with saving. Please click back and try again.');
          console.log('Error: /frontend/src/components/VerificationForms/CreateVerificationForm//formik', err);
        });
      //refresh source grid
      localStorage.setItem('refresh', 'true');
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className='row'>
        <Button
          className='mt-3 ml-4 float-left'
          onClick={() => {
            window.history.back();
          }}>
          Back
        </Button>

        <Button disabled={updateDisabled} type='submit' variant='info' className='mt-3 ml-3 float-right'>
          Create Verification
        </Button>
      </div>
      <div className='row mt-3'>
        <div className='col-sm-6'>
          <div className='form-group form-inline'>
            <label className='col-sm-3'>ID</label>
            <input disabled id='id' name='id' className='form-control col-sm-8' value={String(formik.values.id)} />
          </div>

          <StatusDropdown formik={formik} />

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Bar Code</label>
            <input
              disabled
              id='barCode'
              name='barCode'
              className='form-control col-sm-8'
              onChange={formik.handleChange}
              value={formik.values.barCode}
            />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Verify Date</label>
            <input
              disabled
              id='verifyDate'
              name='verifyDate'
              className='form-control col-sm-8'
              onChange={formik.handleChange}
              value={String(formik.values.verifyDate)}
            />
          </div>

          <input type='hidden' disabled id='userId' name='userId' className='form-control col-sm-8' onChange={formik.handleChange} value={user.id} />

          <div className='form-group form-inline'>
            <label className='col-sm-3'>User ID</label>
            <input disabled className='form-control col-sm-8' value={user.adId} />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Department of User</label>
            <input
              disabled
              id='userDepartment'
              name='userDepartment'
              className='form-control col-sm-8'
              onChange={formik.handleChange}
              value={user.currentRole.department.Abbreviation}
            />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Type</label>
            <input disabled id='type' name='type' className='form-control col-sm-8' onChange={formik.handleChange} value='V' />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Serial #</label>
            <input disabled id='serialNumber' name='serialNumber' className='form-control col-sm-8' value={formik.values.serialNumber} />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Asset # (from EnterpriseOne)</label>
            <input
              disabled
              id='assetNumber'
              name='assetNumber'
              className='form-control col-sm-8'
              onChange={formik.handleChange}
              value={formik.values.assetNumber}
            />
          </div>

          <DepartmentDropdown formik={formik} />

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Latitude</label>
            <input disabled id='latitude' name='latitude' className='form-control col-sm-8' onChange={formik.handleChange} value='' />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>Longitude</label>
            <input disabled id='longitude' name='longitude' className='form-control col-sm-8' onChange={formik.handleChange} value='' />
          </div>

          <div className='form-group form-inline'>
            <label className='col-sm-3'>IP Address</label>
            <input disabled id='IpAddress' name='IpAddress' className='form-control col-sm-8' onChange={formik.handleChange} value='' />
          </div>
        </div>
        <div className='col-sm-6'>
          <label>Add Comment</label>
          <textarea className='form-control' id='comment' rows={3} value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
          {queryByAssetNumber ? (
            <CommentsTimeline verifyId={null} barCode={null} />
          ) : (
            <CommentsTimeline verifyId={null} barCode={props.data.assetsViewByBarcode.BarCode} />
          )}
        </div>
      </div>
    </Form>
  );
};

export default CreateVerificationForm;
